








































































import { Component, Mixins, Prop, Emit, Ref } from "vue-property-decorator";
import AppToolTip from "#/components/AppToolTip.vue";
import AppDataTable from "#/components/AppDataTable.vue";

import { DataTableHeader } from "vuetify/types/index";
import { PortalOffice } from "@/model/portal";
import UtilMixin from "@/mixins/utilMixin";
import SelectFilter from "#/components/selectFilter/SelectFilter.vue";
import { SELECT_FILTER } from "#/const";
import {
  ColumnKey,
  HeaderColumn,
  IsFilterMatch,
} from "#/components/selectFilter/filter";

@Component({
  components: {
    AppToolTip,
    SelectFilter,
    AppDataTable,
  },
})
export default class SendTargetList extends Mixins(UtilMixin) {
  /** 送信先事業所情報 */
  @Prop({ default: () => [] }) private value!: [];

  /** フォーム非活性 */
  @Prop({ default: false }) private disabled!: boolean;

  /** 事業所情報 */
  @Prop({ default: () => [] }) private offices!: PortalOffice[];

  @Ref("selectFilter") private readonly selectFilter!: SelectFilter;

  /** 絞込み用キーワード */
  private searchKey = "";

  private get innerValue(): PortalOffice[] {
    return this.value.slice();
  }

  private set innerValue(newValue: PortalOffice[]) {
    this.input(newValue);
  }

  /** 選択可能事業所情報 */
  private get srcOffices(): PortalOffice[] {
    if (!this.innerValue.length) {
      return this.offices;
    }

    return this.offices.filter((office: PortalOffice) => {
      let match = false;
      this.innerValue.forEach((data: PortalOffice) => {
        if (office.id == data.id) {
          match = true;
        }
      });
      return !match;
    });
  }

  /** 送信先事業所情報 */
  private get distOffices(): PortalOffice[] {
    return this.innerValue.slice();
  }

  /** 選択可能事業所の中でチェックが入った事業所情報 */
  private selectedSrcOffices: PortalOffice[] = [];

  /** 送信先事業所の中でチェックが入った事業所情報 */
  private selectedDistOffices: PortalOffice[] = [];

  /** 選択可能事業所 -> 送信先事業所への移動 */
  private toDistOffices() {
    // 1つもチェックが入っていないままボタンが押された場合は何もしない
    if (!this.selectedSrcOffices.length) {
      return;
    }

    // 送信先事業所情報に追加
    this.innerValue = [...this.innerValue, ...this.selectedSrcOffices];

    // チェック状態を初期化
    this.selectedSrcOffices = [];
  }

  /** 送信先事業所 -> 選択可能事業所への移動 */
  private toSrcOffices() {
    // 1つもチェックが入っていないままボタンが押された場合は何もしない
    if (!this.selectedDistOffices.length) {
      return;
    }

    // 送信先事業所情報から削除
    this.innerValue = this.innerValue.filter((office: PortalOffice) => {
      let match = false;
      this.selectedDistOffices.forEach((data: PortalOffice) => {
        if (office.id == data.id) {
          match = true;
        }
      });
      return !match;
    });

    // チェック状態を初期化
    this.selectedDistOffices = [];
  }

  /** v-data-table用送る事業所ヘッダー情報 */
  private nonFilterHeaders: DataTableHeader[] = [
    {
      text: "介護事業所番号",
      value: "office_code",
    },
    {
      text: "医療機関コード",
      value: "medical_institution_code",
    },
    {
      text: "事業所名",
      value: "name",
    },
  ];

  /** ヘッダー情報 */
  private get headers(): HeaderColumn[] {
    return [
      {
        text: "介護事業所番号",
        value: "office_code",
        sortable: true,
        align: "center",
        width: "100px",
        filter: (val: object) => this.columnFilter("office_code", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "office_code",
          text: "介護事業所番号",
          selectable: [],
        },
      },
      {
        text: "医療機関コード",
        value: "medical_institution_code",
        sortable: true,
        align: "center",
        width: "100px",
        filter: (val: object) =>
          this.columnFilter("medical_institution_code", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "medical_institution_code",
          text: "医療機関コード",
          selectable: [],
        },
      },
      {
        text: "事業所名",
        value: "name",
        sortable: true,
        align: "center",
        width: "100px",
        filter: (val: object) => this.columnFilter("name", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "name",
          text: "事業所名",
          selectable: [],
        },
      },
    ];
  }

  /**
   * SelectFilterの選択肢
   * @return ColumnKey
   */
  private get columnKeys(): ColumnKey[] {
    const keys = this.headers
      .filter((headerColumn: HeaderColumn) => headerColumn.filter != null)
      .map((headerColumn: HeaderColumn) => headerColumn.columnKey);

    if (keys.length == 0) {
      return [] as ColumnKey[];
    }

    return keys as ColumnKey[];
  }

  /** カラムフィルター */
  private columnFilter(key: string, val: unknown) {
    const bret = IsFilterMatch(
      this.selectFilter.filterClauses,
      key,
      val as string | number
    );
    return bret;
  }

  @Emit()
  private input(newOffices: PortalOffice[]): PortalOffice[] {
    return newOffices;
  }
}
